import { render, staticRenderFns } from "./TestimonialBlocks.vue?vue&type=template&id=ae112be6&lang=pug&"
import script from "./TestimonialBlocks.vue?vue&type=script&lang=js&"
export * from "./TestimonialBlocks.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialBlocks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae112be6')) {
      api.createRecord('ae112be6', component.options)
    } else {
      api.reload('ae112be6', component.options)
    }
    module.hot.accept("./TestimonialBlocks.vue?vue&type=template&id=ae112be6&lang=pug&", function () {
      api.rerender('ae112be6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/TestimonialBlocks.vue"
export default component.exports